<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1ArANgz/tc-custom/9781617459245.jpg?1703224413244" alt="This image is the cover for the book Sew Magical"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sew Magical
      </h1>
      <p class="bookDescription body article font2">
        <b>Create a fairy tale world of unicorns, dragons, mermaids, and more with these paper-piecing projects by the author of <i>Cute &amp; Clever Totes</i>.</b><br/><br/>From mystical creatures to a royal princess, a castle, and a brave knight, Mary Hertel’s beloved paper-pieced blocks are simple to sew and easy to love. With sixteen mix-and-match blocks, you’ll unlock the power of imagination in your quilting. Combine the blocks to create seven cute and useful projects ranging from quilts and pillows to a drawstring backpack. With clever patterns and clear instructions, this collection will help paper piecers see that anything is possible.Step-by-step patterns from paper-piecing wizard Mary HertelPiece sixteen blocks of mythic proportions—fairies, a cyclops, a gryphon, and moreShow off the blocks in baby quilts, a wallhanging, or cute pillows for a kids’ bedroom
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Hertel
      </h2>
      
      <p class="authorDescription body article">Mary Hertel Bio: Mary Hertel is a pattern designer, teacher, and author. She teaches quilting regionally and online. Mary’s work has appeared in a number of magazines and she’s been featured on quilting podcasts and television programs. She lives in Oshkosh, Wisconsin. madebymarney.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      C&T Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4b441936